import React from "react";
import { Box, Container } from "@mui/material";
import NavBar from "./NavBarWithSearch";

const Layout = ({ children, hideNavBar }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        bgcolor: "#000000",
      }}
    >
      {!hideNavBar && <NavBar />}

      <Box
        component="main"
        sx={{
          flex: 1, // Allow this box to grow and fill available space
          overflowY: "auto", // Add scrolling to this container
          py: { xs: 2, md: 3 },
          px: { xs: 2, md: 3 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            py: { xs: 2, md: 3 },
            px: { xs: 1, md: 2 },
          }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default Layout;
